module.exports = __webpack_public_path__ + "static/scale-model-of-tanks-a-lot-dive-charters-in-clearwater-florida-521d8f42f77057bb191e9ea18ede7dab.png";